import styles from "./RekomEventLoadingAnimation.module.scss";
import React, { useEffect, useState } from "react";
import rekomEventLoadingGif from "assets/rekom-event-logo-animation.gif";

const RekomEventLoadingAnimation = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={styles.logo}>
      {/* Media */}
      {!loading ? <img src={rekomEventLoadingGif} alt="loading" /> : null}
    </div>
  );
};

export default RekomEventLoadingAnimation;
